import React, { useEffect } from "react"
import parse from "html-react-parser"
import ArticleFeedback from "./ArticleFeedback"
import Typography from "aldoo-ra/Typography"
import ReadTimeBadge from "../../Blog/read-time-badge"
import TextBundle from "aldoo-ra/CMS/text-bundle"
// Import the updateCDNUrls function from the BlogEditor
import { updateCDNUrls } from "aldoo-ra/Blog/Editor"

/**
 * Article content component
 * @param {Object} props
 * @param {Object} props.article - Article data
 * @param {Function} props.onFeedback - Handler for feedback
 */
const ArticleContent = ({ article, onFeedback }) => {
  const texts = TextBundle({ id: "help-center" })
  if (!article) return null

  const formatDate = (dateString) => {
    if (!dateString) return ""
    const date = new Date(dateString)
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  }

  // Extract values based on the actual structure
  const title = article.content.name || "Untitled Article"
  const lastUpdated =
    article.lastUpdated || article.updatedAt || article.createdAt

  // Update document title when component mounts or title changes
  useEffect(() => {
    document.title = `${title} - Mobilingo Help Center`
    
    // Cleanup - restore original title when component unmounts
    return () => {
      document.title = "Mobilingo Help Center"
    }
  }, [title])

  // Get content - ONLY parse content.content as specified
  const getContent = () => {
    // Only check for article.content.content
    if (article.content && typeof article.content.content === "string") {
      // Process CDN URLs before parsing using the reusable function
      const processedContent = updateCDNUrls(article.content.content)
      return parse(processedContent)
    }
    // Fallback
    return (
      <Typography variant="body1">
        {texts?.empty_article ||
          "No content available for this article."}
      </Typography>
    )
  }
  return (
    <article className="hc">
      <div className="flex flex-col gap-5 pb-4">
        <Typography variant="h2" className="my-0">
          {title}
        </Typography>
        
        <ReadTimeBadge
          data={article.content}
          position="relative"
          top="auto"
          topMd="auto"
          right="auto"
          rightMd="auto"
          textClassName="text-text"
          bgColor="bg-primary_lt"
          className="w-fit"
        />

        {lastUpdated && (
          <div className="flex items-center text-gray_700 mb-4">
            <Typography variant="txt1_dim" className="mr-1 my-0">
              {texts?.update_date || "Last updated on"}:
            </Typography>
            <time dateTime={lastUpdated}>{formatDate(lastUpdated)}</time>
          </div>
        )}
      </div>

      <div className="article_content max-w-[860px]">{getContent()}</div>

      <ArticleFeedback article={article} onFeedback={onFeedback} />
    </article>
  )
}

export default ArticleContent